@import "~@uipath/apollo-core/src/scss/base-host.scss";
@import "./../portal-menu-item/portal-menu-item.scss";

.menu-link-base {
  padding: 0px;
  min-height: 32px;
  cursor: pointer;
  text-decoration: none;
  min-width: 192px;
}

.menu-link-text {
  padding: 0px $pad-xxxl;
  flex: 1;
  text-align: left;
}
